module.exports = __webpack_public_path__ + "static/media/phone_white_WEB_CHANGE_6.148bda37.png";